<form [formGroup]="form" class="sf" novalidate>

  <!-- Area -->
  <section class="sf-section">
    <h3 id="sf-area" class="sf-section__title">¿Con qué parte necesitas ayuda? <span class="sf-req" aria-hidden="true">*</span></h3>
    <div class="sf-areas" role="radiogroup" aria-labelledby="sf-area" aria-required="true"
      [attr.aria-describedby]="showError('category') ? 'sf-category-error' : null">
      @for (cat of categories; track cat.value) {
        <label class="sf-area">
          <input type="radio" formControlName="category" [value]="cat.value" class="sr-only" />
          <span class="sf-area__box">
            <svg class="sf-area__icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="cat.icon" />
            </svg>
            <span class="sf-area__label">{{ cat.label }}</span>
            <span class="sf-area__hint">{{ cat.hint }}</span>
          </span>
        </label>
      }
    </div>
    @if (showError('category')) {
      <p id="sf-category-error" class="sf-error" role="alert">Elige el área para que el caso llegue a la persona correcta.</p>
    }
  </section>

  <!-- What happened -->
  <section class="sf-section" aria-labelledby="sf-what">
    <h3 id="sf-what" class="sf-section__title">Cuéntanos qué pasa</h3>

    <div>
      <label for="sf-subject" class="sf-label">Resumen <span class="sf-req" aria-hidden="true">*</span></label>
      <input id="sf-subject" type="text" formControlName="subject" [attr.maxlength]="subjectMax"
        placeholder="Ej: No puedo mover una cita a otro día"
        class="sf-input" [class.sf-input--error]="showError('subject')"
        aria-required="true" [attr.aria-invalid]="showError('subject')"
        [attr.aria-describedby]="showError('subject') ? 'sf-subject-error' : null" />
      @if (showError('subject')) {
        <p id="sf-subject-error" class="sf-error" role="alert">Escribe un resumen de al menos 5 caracteres.</p>
      }
    </div>

    <div>
      <label for="sf-description" class="sf-label">Detalle <span class="sf-req" aria-hidden="true">*</span></label>
      <textarea id="sf-description" rows="6" formControlName="description" [attr.maxlength]="descriptionMax"
        placeholder="Qué intentabas hacer, qué esperabas que pasara y qué pasó. Si aparece un mensaje de error, cópialo aquí."
        class="sf-input sf-input--area" [class.sf-input--error]="showError('description')"
        aria-required="true" [attr.aria-invalid]="showError('description')"
        aria-describedby="sf-description-count"></textarea>
      <div class="sf-row">
        @if (showError('description')) {
          <p class="sf-error" role="alert">Describe el problema con al menos 20 caracteres.</p>
        } @else {
          <p class="sf-hint">Entre más contexto, más rápido lo resolvemos.</p>
        }
        <span id="sf-description-count" class="sf-count">{{ length('description') }} / {{ descriptionMax }}</span>
      </div>
    </div>
  </section>

  <!-- Impact -->
  <section class="sf-section">
    <h3 id="sf-impact" class="sf-section__title">¿Qué tanto te afecta?</h3>
    <div class="sf-impacts" role="radiogroup" aria-labelledby="sf-impact">
      @for (impact of impacts; track impact.value) {
        <label class="sf-impact" [attr.data-impact]="impact.value">
          <input type="radio" formControlName="impact" [value]="impact.value" class="sr-only" />
          <span class="sf-impact__box">
            <span class="sf-impact__mark" aria-hidden="true"></span>
            <span class="sf-impact__text">
              <span class="sf-impact__label">{{ impact.label }}</span>
              <span class="sf-impact__hint">{{ impact.hint }}</span>
            </span>
          </span>
        </label>
      }
    </div>
  </section>

  <!-- Contact -->
  <section class="sf-section" aria-labelledby="sf-contact">
    <h3 id="sf-contact" class="sf-section__title">Cómo te contactamos</h3>
    @if (replyEmail) {
      <p class="sf-hint sf-hint--flush">Te respondemos por correo a <strong>{{ replyEmail }}</strong>.</p>
    }
    <div>
      <label for="sf-phone" class="sf-label">Teléfono <span class="sf-optional">opcional</span></label>
      <input id="sf-phone" type="tel" inputmode="tel" formControlName="contactPhone" maxlength="50"
        placeholder="Por si es más fácil llamarte" class="sf-input" autocomplete="tel" />
    </div>
  </section>
</form>
